import SEO from "@/components/SEO";
import PageHeader from "@/components/PageHeader";
import ProcessTimeline from "@/sections/ProcessTimeline";
import WhyChooseUs from "@/sections/WhyChooseUs";
import CTABanner from "@/components/CTABanner";

export default function ProcessPage() {
  return (
    <>
      <SEO
        title="Our Process — How We Work"
        description="Our proven 7-step process — Discover, Strategy, Design, Development, Optimization, Launch and Growth — delivers predictable results for your business."
        path="/process"
      />
      <PageHeader
        eyebrow="Our process"
        title="A deliberate path to"
        highlight="predictable growth"
        subtitle="No guesswork. Every engagement follows a proven framework built for measurable outcomes."
      />
      <ProcessTimeline showHeader={false} />
      <WhyChooseUs />
      <div className="py-10"><CTABanner /></div>
    </>
  );
}
